import React from "react";
import SectionShell from "../../shared/SectionShell";

const personCardStyle = {
  border: "1px solid var(--border, #e5e5e5)",
  borderRadius: 12,
  padding: 12,
  background: "#fafafa",
  display: "grid",
  gap: 10,
};

const StudentFamilyTab = ({
  formData,
  cardStyle,
  labelStyle,
  inputStyle,
  textareaStyle,
  miniActionBtnStyle,
  photoCircleStyle,
  handleChange,
  handleGuardianChange,
  handleGuardianPhotoChange,
  addGuardian,
  removeGuardian,
  setPrimaryGuardian,
}) => {
  return (
    <SectionShell
      title="Family / Guardians"
      subtitle="Primary guardians, emergency contacts, and authorized pickup permissions."
    >
      <div style={{ display: "grid", gap: 16 }}>
        <div style={cardStyle}>
          <div style={labelStyle}>Primary Guardians</div>

          {(formData.primaryGuardians || []).length ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                gap: 12,
                marginTop: 10,
              }}
            >
              {(formData.primaryGuardians || []).map((guardian, index) => {
                const guardianId = guardian._id || `primary-${index}`;

                return (
                  <div key={guardianId} style={personCardStyle}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: 12,
                        flexWrap: "wrap",
                      }}
                    >
                      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                        <label
                          htmlFor={`primary-photo-${guardianId}`}
                          style={{ ...photoCircleStyle, cursor: "pointer" }}
                          title="Upload guardian photo"
                        >
                          {guardian.photo ? (
                            <img
                              src={guardian.photo}
                              alt={guardian.name || "Guardian"}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "50%",
                              }}
                            />
                          ) : (
                            <span style={{ fontSize: ".78rem", textAlign: "center" }}>Photo</span>
                          )}
                        </label>

                        <input
                          id={`primary-photo-${guardianId}`}
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={(e) =>
                            handleGuardianPhotoChange(
                              "primaryGuardians",
                              guardian._id,
                              e.target.files?.[0]
                            )
                          }
                        />

                        <div>
                          <div style={{ fontWeight: 800 }}>
                            {guardian.name || `Guardian ${index + 1}`}
                          </div>
                          <div style={{ color: "var(--text-secondary, #666)", fontSize: ".92rem" }}>
                            Parent / guardian contact
                          </div>
                        </div>
                      </div>

                      <button
                        type="button"
                        style={miniActionBtnStyle}
                        onClick={() => removeGuardian("primaryGuardians", guardian._id)}
                      >
                        Remove
                      </button>
                    </div>

                    <label style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                      <input
                        type="radio"
                        name="primaryGuardian"
                        checked={!!guardian.isPrimary}
                        onChange={() => setPrimaryGuardian(guardian._id)}
                      />
                      Set as primary guardian
                    </label>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                        gap: 10,
                      }}
                    >
                      <div>
                        <div style={labelStyle}>Guardian Name</div>
                        <input
                          style={inputStyle}
                          value={guardian.name || ""}
                          onChange={(e) =>
                            handleGuardianChange(
                              "primaryGuardians",
                              guardian._id,
                              "name",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      <div>
                        <div style={labelStyle}>Relationship</div>
                        <input
                          style={inputStyle}
                          value={guardian.relationship || ""}
                          onChange={(e) =>
                            handleGuardianChange(
                              "primaryGuardians",
                              guardian._id,
                              "relationship",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      <div>
                        <div style={labelStyle}>Email</div>
                        <input
                          style={inputStyle}
                          value={guardian.email || ""}
                          onChange={(e) =>
                            handleGuardianChange(
                              "primaryGuardians",
                              guardian._id,
                              "email",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      <div>
                        <div style={labelStyle}>Phone</div>
                        <input
                          style={inputStyle}
                          value={guardian.phone || ""}
                          onChange={(e) =>
                            handleGuardianChange(
                              "primaryGuardians",
                              guardian._id,
                              "phone",
                              e.target.value
                            )
                          }
                        />
                      </div>
                    </div>

                    <div>
                      <div style={labelStyle}>Address</div>
                      <input
                        style={inputStyle}
                        value={guardian.address || ""}
                        onChange={(e) =>
                          handleGuardianChange(
                            "primaryGuardians",
                            guardian._id,
                            "address",
                            e.target.value
                          )
                        }
                      />
                    </div>

                    <div>
                      <div style={labelStyle}>Notes</div>
                      <textarea
                        style={textareaStyle}
                        value={guardian.notes || ""}
                        onChange={(e) =>
                          handleGuardianChange(
                            "primaryGuardians",
                            guardian._id,
                            "notes",
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div style={{ color: "var(--text-secondary, #666)", marginTop: 10 }}>
              No primary guardians added yet.
            </div>
          )}

          <div style={{ marginTop: 12 }}>
            <button
              type="button"
              style={miniActionBtnStyle}
              onClick={() => addGuardian("primaryGuardians")}
            >
              + Add Guardian
            </button>
          </div>
        </div>

        <div style={cardStyle}>
          <div style={labelStyle}>Emergency Contact</div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: 10,
              marginTop: 10,
            }}
          >
            <div>
              <div style={labelStyle}>Name</div>
              <input
                style={inputStyle}
                value={formData.emergencyContactName || ""}
                onChange={(e) => handleChange("emergencyContactName", e.target.value)}
              />
            </div>

            <div>
              <div style={labelStyle}>Relationship</div>
              <input
                style={inputStyle}
                value={formData.emergencyContactRelationship || ""}
                onChange={(e) => handleChange("emergencyContactRelationship", e.target.value)}
              />
            </div>

            <div>
              <div style={labelStyle}>Phone</div>
              <input
                style={inputStyle}
                value={formData.emergencyContactPhone || ""}
                onChange={(e) => handleChange("emergencyContactPhone", e.target.value)}
              />
            </div>

            <div>
              <div style={labelStyle}>Email</div>
              <input
                style={inputStyle}
                value={formData.emergencyContactEmail || ""}
                onChange={(e) => handleChange("emergencyContactEmail", e.target.value)}
              />
            </div>
          </div>

          <div style={{ marginTop: 10 }}>
            <div style={labelStyle}>Notes</div>
            <textarea
              style={textareaStyle}
              value={formData.emergencyContactNotes || ""}
              onChange={(e) => handleChange("emergencyContactNotes", e.target.value)}
            />
          </div>
        </div>

        <div style={cardStyle}>
          <div style={labelStyle}>Authorized Pickups</div>

          {(formData.authorizedPickups || []).length ? (
            <div style={{ display: "grid", gap: 12, marginTop: 10 }}>
              {(formData.authorizedPickups || []).map((pickup, index) => {
                const pickupId = pickup._id || `pickup-${index}`;

                return (
                  <div key={pickupId} style={personCardStyle}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: 12,
                        flexWrap: "wrap",
                      }}
                    >
                      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                        <label
                          htmlFor={`pickup-photo-${pickupId}`}
                          style={{ ...photoCircleStyle, cursor: "pointer" }}
                          title="Upload pickup photo"
                        >
                          {pickup.photo ? (
                            <img
                              src={pickup.photo}
                              alt={pickup.name || "Authorized Pickup"}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "50%",
                              }}
                            />
                          ) : (
                            <span style={{ fontSize: ".78rem", textAlign: "center" }}>Photo</span>
                          )}
                        </label>

                        <input
                          id={`pickup-photo-${pickupId}`}
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={(e) =>
                            handleGuardianPhotoChange(
                              "authorizedPickups",
                              pickup._id,
                              e.target.files?.[0]
                            )
                          }
                        />

                        <div>
                          <div style={{ fontWeight: 800 }}>
                            {pickup.name || `Pickup ${index + 1}`}
                          </div>
                          <div style={{ color: "var(--text-secondary, #666)", fontSize: ".92rem" }}>
                            Approved pickup contact
                          </div>
                        </div>
                      </div>

                      <button
                        type="button"
                        style={miniActionBtnStyle}
                        onClick={() => removeGuardian("authorizedPickups", pickup._id)}
                      >
                        Remove
                      </button>
                    </div>

                    <label style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                      <input
                        type="checkbox"
                        checked={!!pickup.authorized}
                        onChange={(e) =>
                          handleGuardianChange(
                            "authorizedPickups",
                            pickup._id,
                            "authorized",
                            e.target.checked
                          )
                        }
                      />
                      Authorized for pickup
                    </label>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                        gap: 10,
                      }}
                    >
                      <div>
                        <div style={labelStyle}>Name</div>
                        <input
                          style={inputStyle}
                          value={pickup.name || ""}
                          onChange={(e) =>
                            handleGuardianChange(
                              "authorizedPickups",
                              pickup._id,
                              "name",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      <div>
                        <div style={labelStyle}>Relationship</div>
                        <input
                          style={inputStyle}
                          value={pickup.relationship || ""}
                          onChange={(e) =>
                            handleGuardianChange(
                              "authorizedPickups",
                              pickup._id,
                              "relationship",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      <div>
                        <div style={labelStyle}>Phone</div>
                        <input
                          style={inputStyle}
                          value={pickup.phone || ""}
                          onChange={(e) =>
                            handleGuardianChange(
                              "authorizedPickups",
                              pickup._id,
                              "phone",
                              e.target.value
                            )
                          }
                        />
                      </div>

                      <div>
                        <div style={labelStyle}>Email</div>
                        <input
                          style={inputStyle}
                          value={pickup.email || ""}
                          onChange={(e) =>
                            handleGuardianChange(
                              "authorizedPickups",
                              pickup._id,
                              "email",
                              e.target.value
                            )
                          }
                        />
                      </div>
                    </div>

                    <div>
                      <div style={labelStyle}>Notes</div>
                      <textarea
                        style={textareaStyle}
                        value={pickup.notes || ""}
                        onChange={(e) =>
                          handleGuardianChange(
                            "authorizedPickups",
                            pickup._id,
                            "notes",
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div style={{ color: "var(--text-secondary, #666)", marginTop: 10 }}>
              No authorized pickups added yet.
            </div>
          )}

          <div style={{ marginTop: 12 }}>
            <button
              type="button"
              style={miniActionBtnStyle}
              onClick={() => addGuardian("authorizedPickups")}
            >
              + Add Authorized Pickup
            </button>
          </div>
        </div>
      </div>
    </SectionShell>
  );
};

export default StudentFamilyTab;